import { createSelector } from 'reselect'

export const authState = (state) => state.auth

export const authSelectors = createSelector(authState, (state) => state)
